/* @flow */
import SchoolEngagementBanner from './SchoolEngagementBanner';

export default SchoolEngagementBanner;
